/* eslint-disable prettier/prettier */
import React from 'react';
import styles from './UpcomingActivityCard.module.css';

export interface UpcomingActivityCardProps {
	programLabel?: string;
	icon?: string;

	title: string;
	subtitle?: string;

	date?: string;
	time?: string;

	primaryButtonText?: string;
	secondaryButtonText?: string;

	onPrimaryClick?: () => void;
	onSecondaryClick?: () => void;

	disabled?: boolean;

	mentorImage?: string;

	className?: string;

	primaryButtonColor?: string;
	primaryButtonTextColor?: string;
}

const UpcomingActivityCard: React.FC<UpcomingActivityCardProps> = ({
	programLabel = 'IMPACT LEVEL 1 ICF ACC',
	icon,
	title,
	subtitle = 'Session by Rupinder Kaur',

	date = '2 April 2026',
	time = '10:00 - 11:00 AM',

	primaryButtonText = 'Join Now',
	secondaryButtonText = 'View Program',

	onPrimaryClick,
	onSecondaryClick,

	disabled = false,

	mentorImage,

	className = '',

	primaryButtonColor = '#147B58',
	primaryButtonTextColor = '#FFFFFF',
}) => {
	return (
		<div className={`${styles.card} ${className}`}>
			{/* LEFT */}
			<div className={styles.leftSection}>
				<div className={styles.topRow}>
					{icon && (
						<div className={styles.iconWrapper}>
							<img
								src={icon}
								alt="icon"
								className={styles.icon}
							/>
						</div>
					)}

					<span className={styles.programLabel}>{programLabel}</span>
				</div>

				<h3 className={styles.title}>{title}</h3>

				<p className={styles.subtitle}>{subtitle}</p>
			</div>

			{/* CENTER */}
			<div className={styles.centerSection}>
				<div className={styles.badge}>{date}</div>

				<div className={styles.badge}>{time}</div>
			</div>

			{/* RIGHT */}
			<div className={styles.rightSection}>
				<button
					className={styles.secondaryButton}
					onClick={onSecondaryClick}
				>
					{secondaryButtonText}
				</button>

				<button
					className={`${styles.primaryButton} ${
						disabled ? styles.disabledButton : ''
					}`}
					onClick={onPrimaryClick}
					disabled={disabled}
					style={{
						background: disabled ? '#D9D9D9' : primaryButtonColor,
						color: disabled ? '#FFFFFF' : primaryButtonTextColor,
					}}
				>
					{primaryButtonText}
				</button>

				{mentorImage && (
					<div className={styles.avatarWrapper}>
						<img
							src={mentorImage}
							alt="mentor"
							className={styles.avatar}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default UpcomingActivityCard;
